import { CommonModule } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { LmsService } from "../../_Lms/services/lms.service";
import { LosService } from "../../_LOS/services/los.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { DialogService } from "../../Shared/dialog.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
declare var $: any;

import { MasterService } from "../../Shared/app.Masters.Service";

@Component({
    selector: "app-settings-login",
    templateUrl: "./settings-login.component.html",
    styleUrls: ["./settings-login.component.scss"],
    imports: [CommonModule, FormsModule]
})
export class SettingsLoginComponent implements OnInit {
  currentUserId: any;
  password: string = "";
  showPassword: boolean = false;
  isLoading: boolean = false;
  Message: string = "";

    configSuccess: MatSnackBarConfig = {
      panelClass: "style-success",
      duration: 5000,
      horizontalPosition: "right",
      verticalPosition: "top",
    };
  constructor(
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private _MasterService: MasterService,
    private lmsService: LmsService,
    private losService: LosService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private dialog: DialogService,
  ) {}
  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Settings Login");
    this.currentUserId = JSON.parse(sessionStorage.getItem("currentUser"));
    console.log("Current User ID:", this.currentUserId);
    if (this.currentUserId.userId !== 1 && this.currentUserId.userId !== 2) {
      this.router.navigate(["/Login"]);
    }
  }

  onSubmit(form: any) {
    if (form.invalid) return;
    this.Message = "";
    this.isLoading = true;
    this._MasterService.SettingsLogin({ Password: this.password }).subscribe(
      (result: any) => {
        console.log(result);
        if (result.CODE === 0) {
          this.Message = result.MSG;
          setTimeout(() => {
            this.router.navigate(["/confidential/Home"]);
          }, 1000);
          this.snackBar.openFromComponent(SnackbarComponent, {
                    data: result[0].MSG,
                    ...this.configSuccess,
                  });

        } else {
          this.Message = result.MSG;

          this.isLoading = false;
        }
        this.isLoading = false;
      },
    );
  }
toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }
}
